import { makeBox } from "@seneca/senekit";

import flagAustralia, {
  ReactComponent as FlagAustralia
} from "common/assets/images/flags/australia.svg";
import flagAustria, {
  ReactComponent as FlagAustria
} from "common/assets/images/flags/austria.svg";
import flagBR, {
  ReactComponent as FlagBR
} from "common/assets/images/flags/brazil.svg";
import flagColombia, {
  ReactComponent as FlagColombia
} from "common/assets/images/flags/colombia.svg";
import flagFR, {
  ReactComponent as FlagFR
} from "common/assets/images/flags/france.svg";
import flagGermany, {
  ReactComponent as FlagGermany
} from "common/assets/images/flags/germany.svg";
import flagIndia, {
  ReactComponent as FlagIndia
} from "common/assets/images/flags/india.svg";
import flagItaly, {
  ReactComponent as FlagItaly
} from "common/assets/images/flags/italy.svg";
import flagMX, {
  ReactComponent as FlagMX
} from "common/assets/images/flags/mexico.svg";
import flagSpain, {
  ReactComponent as FlagSpain
} from "common/assets/images/flags/spain.svg";
import flagUK, {
  ReactComponent as FlagUK
} from "common/assets/images/flags/uk.svg";
import flagUS, {
  ReactComponent as FlagUS
} from "common/assets/images/flags/usa.svg";
import flagVietnam, {
  ReactComponent as FlagVietnam
} from "common/assets/images/flags/vietnam.svg";

export const regionMetas = {
  GB: {
    flag: flagUK,
    FlagComponent: makeBox(FlagUK)
  },
  BR: {
    flag: flagBR,
    FlagComponent: makeBox(FlagBR)
  },
  FR: {
    flag: flagFR,
    FlagComponent: makeBox(FlagFR)
  },
  MX: {
    flag: flagMX,
    FlagComponent: makeBox(FlagMX)
  },
  US: {
    flag: flagUS,
    FlagComponent: makeBox(FlagUS)
  },
  IN: {
    flag: flagIndia,
    FlagComponent: makeBox(FlagIndia)
  },
  AU: {
    flag: flagAustralia,
    FlagComponent: makeBox(FlagAustralia)
  },
  CO: {
    flag: flagColombia,
    FlagComponent: makeBox(FlagColombia)
  },
  VN: {
    flag: flagVietnam,
    FlagComponent: makeBox(FlagVietnam)
  },
  AT: {
    flag: flagAustria,
    FlagComponent: makeBox(FlagAustria)
  },
  DE: {
    flag: flagGermany,
    FlagComponent: makeBox(FlagGermany)
  },
  ES: {
    flag: flagSpain,
    FlagComponent: makeBox(FlagSpain)
  },
  IT: {
    flag: flagItaly,
    FlagComponent: makeBox(FlagItaly)
  }
};
